<ng-container [kitComponent]="model.header"></ng-container>
<div class="list-group list-group-flush app-accounting-list-items">
  <button *ngFor="let item of model.items" [kitModel]="item" type="button"
          class="list-group-item list-group-item-action">
  </button>
</div>

